<script setup lang="ts">
import { useDisplay } from 'vuetify/framework'

interface Props {
  confirmationQuestion: string
  isDialogVisible?: boolean
  confirmTitle?: string
  confirmationText?: string
  confirmMsg?: string
  cancelTitle?: string
  cancelMsg?: string
  confirmBtn: string
  rejectBtn?: string | null
}

interface Emit {
  (e: 'update:isDialogVisible', value: boolean): void
  (e: 'confirm', value: boolean): void
}

const props = defineProps<Props>()

const emit = defineEmits<Emit>()

const { xs } = useDisplay()

const unsubscribed = ref(false)
const cancelled = ref(false)

const updateModelValue = (val: boolean) => {
  emit('update:isDialogVisible', val)
}

const onConfirmation = () => {
  emit('confirm', true)
/*  updateModelValue(false)
  unsubscribed.value = true */
}

const onCancel = () => {
  emit('confirm', false)
/*  emit('update:isDialogVisible', false)
  cancelled.value = true */
}
</script>

<template>
  <!-- 👉 Confirm Dialog -->
  <VDialog
    max-width="560"
    :model-value="props.isDialogVisible"
    class="confirm-dialog"
    content-class="entity-form-menu"
    @update:model-value="updateModelValue"
  >
    <VCard class="pa-5 d-flex flex-column gap-2">
      <div class="text-h5">
        {{ confirmationQuestion }}
      </div>

      <div>
        {{ confirmationText }}
      </div>
      <div class="d-flex gap-2" :class="{ 'flex-column': xs }">
        <VBtn
          v-if="rejectBtn"
          :class="xs ? 'w-100' : 'flex-1-1-0'"
          color="secondary"
          variant="outlined"
          @click="onCancel"
        >
          {{ rejectBtn }}
        </VBtn>

        <VBtn
          :class="xs ? 'w-100' : 'flex-1-1-0'"
          variant="elevated"
          @click="onConfirmation"
        >
          {{ confirmBtn }}
        </VBtn>
      </div>
    </VCard>
  </VDialog>

  <!-- Unsubscribed -->
  <VDialog
    v-model="unsubscribed"
    max-width="500"
  >
    <VCard>
      <VCardText class="text-center px-10 py-6">
        <VBtn
          icon
          variant="outlined"
          color="success"
          class="my-4"
          size="x-large"
        >
          <span class="text-xl">
            <VIcon icon="ri-check-line" />
          </span>
        </VBtn>

        <h1 class="text-h4 mb-4">
          {{ props.confirmTitle }}
        </h1>

        <p>{{ props.confirmMsg }}</p>

        <VBtn
          color="success"
          @click="unsubscribed = false"
        >
          Ok
        </VBtn>
      </VCardText>
    </VCard>
  </VDialog>

  <!-- Cancelled -->
  <VDialog
    v-model="cancelled"
    max-width="500"
  >
    <VCard>
      <VCardText class="text-center px-10 py-6">
        <VBtn
          icon
          variant="outlined"
          color="error"
          class="my-4"
          size="x-large"
        >
          <span class="text-2xl font-weight-light">X</span>
        </VBtn>

        <h1 class="text-h4 mb-4">
          {{ props.cancelTitle }}
        </h1>

        <p>{{ props.cancelMsg }}</p>

        <VBtn
          color="success"
          @click="cancelled = false"
        >
          Ok
        </VBtn>
      </VCardText>
    </VCard>
  </VDialog>
</template>
